module.exports = __webpack_public_path__ + "static/img/popup-1.bd977e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/popup-1.png
// module id = mnly
// module chunks = 1